import { createFileRoute } from '@tanstack/react-router'
import { Boxes, PackageCheck, Store } from 'lucide-react'
import { PageHeader } from '@/components/app/states'

export const Route = createFileRoute('/_app/inventory')({
  head: () => ({ meta: [{ title: 'Inventory · Nebueye' }] }),
  component: Inventory,
})

const STEPS = [
  { icon: PackageCheck, title: 'Delivered becomes in stock', body: 'Every delivered order turns into inventory you can count, with cost, SKU and where it came from.' },
  { icon: Boxes, title: 'One place for every unit', body: 'See what you hold by product and by drop, what it cost, and how long it has sat.' },
  { icon: Store, title: 'List where it sells', body: 'Send items to marketplaces like eBay the moment they ship, then track what they sold for.' },
]

function Inventory() {
  return (
    <>
      <PageHeader title="Inventory" description="Coming soon. Here's what it will do." />
      <div className="nebula-soft -mx-4 rounded-none px-4 py-10 sm:mx-0 sm:rounded-2xl sm:px-10">
        <p className="text-title max-w-xl font-semibold text-balance">
          From “it went through” to “it sold”, without a spreadsheet.
        </p>
        <ol className="mt-10 grid gap-8 sm:grid-cols-3">
          {STEPS.map((s, i) => (
            <li key={s.title} className="space-y-2">
              <span className="text-subtle tabular text-xs font-medium">0{i + 1}</span>
              <s.icon className="text-primary size-5" />
              <h3 className="font-semibold">{s.title}</h3>
              <p className="text-muted-foreground text-[14px] leading-6">{s.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </>
  )
}
